import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCredentials, setLoading, setError, resetCredentials } from '../redux/reducers/authReducer';
import authService from '../services/authService';

const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, accessToken, isAuthenticated, isLoading, error } = useSelector((state) => state.auth);

  const login = async (credentials) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    try {
      const data = await authService.login(credentials);
      dispatch(setCredentials({
        accessToken: data.token,
        user: data.user
      }));
      navigate('/dashboard', { replace: true });
    } catch (error) {
      dispatch(setError(error.message || 'Erreur de connexion'));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const logout = async () => {
    try {
      await authService.logout();
    } catch (error) {

    } finally {
      dispatch(resetCredentials());
      navigate('/login', { replace: true });
    }
  };

  return {
    user,
    accessToken,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
  };
};

export default useAuth;